import React from 'react';
import {
       Dialog,
       DialogTitle,
       DialogContent,
       DialogActions,
       Button,
       Box,
       DialogContentText,
} from '@mui/material';

interface ConfirmationDialogsProps {
       showSubmitDialog: boolean;
       showNavigationDialog: boolean;
       onCloseDialog: () => void;
       onConfirmSubmit: () => void;
       onConfirmNavigation: () => void;
}

export const ConfirmationDialogs: React.FC<ConfirmationDialogsProps> = ({
       showSubmitDialog,
       showNavigationDialog,
       onCloseDialog,
       onConfirmSubmit,
       onConfirmNavigation,
}) => {
       return (
              <>
                     {/* Submit Changes Dialog */}
                     <Dialog
                            open={showSubmitDialog}
                            onClose={onCloseDialog}
                     >
                            <DialogTitle>
                                   <Box>
                                          Submit Changes
                                   </Box>
                            </DialogTitle>
                            <DialogContent>
                                      <DialogContentText>
                                                   Are you sure you want to submit your changes? These changes will be applied to all homesites within this division.
                                      </DialogContentText>
                                      <Box mt={2} />
                                      <DialogContentText>
                                                   <span style={{ fontWeight: 'bold' }}>Note:</span> Please allow a few minutes for the changes to be reflected in the system.
                                      </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                   <Button onClick={onCloseDialog} style={{ textTransform: 'none' }}>
                                          Cancel
                                   </Button>
                                   <Button onClick={onConfirmSubmit} variant="contained" style={{ textTransform: 'none' }}>
                                          Submit
                                   </Button>
                            </DialogActions>
                     </Dialog>
              </>
       );
}; 